import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { TransfersDeletedActions } from '../actions';


export const transfersDeletedFeatureKey = 'transfersDeleted';

export interface State {
  transfersDeleted: any[];
  transfersDeletedLoaded: boolean;
  transfersDeletedLoading: boolean;
  transfersDeletedLoadingError: any;
  error: string;
}

export const initialState: State = {
  transfersDeleted: [],
  transfersDeletedLoading: false,
  transfersDeletedLoaded: false,
  transfersDeletedLoadingError: null,
  error: '',
};

const userTransferReducer = createReducer(
  initialState,
  on(TransfersDeletedActions.loadTransfersDeleted, (state) => ({
    ...state,
    transfersDeletedLoading: true,
    transfersDeleted: initialState.transfersDeleted,
    transfersDeletedLoaded: initialState.transfersDeletedLoaded,
    transfersDeletedLoadingError: initialState.transfersDeletedLoadingError,
  })),
  on(TransfersDeletedActions.loadTransfersDeletedSuccess, (state, { transfers }) => ({
    ...state,
    transfersDeleted: transfers,
    transfersDeletedLoaded: true,
    transfersDeletedLoading: initialState.transfersDeletedLoading,
    transfersDeletedLoadingError: initialState.transfersDeletedLoadingError,
  })),
  on(TransfersDeletedActions.loadTransfersDeletedFailure, (state, { error }) => ({
    ...state,
    error,
    transfersDeleted: initialState.transfersDeleted,
    transfersDeletedLoadingError: error,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return userTransferReducer(state, action);
}

export const getUserTransferState = createFeatureSelector<State>('transfersDeleted');

export const getTransfersDeleted = createSelector(
  getUserTransferState,
  (state: State) => state.transfersDeleted
);

export const getTransfersDeletedLoading = createSelector(
  getUserTransferState,
  (state: State) => state.transfersDeletedLoading
);

export const getTransfersDeletedLoaded = createSelector(
  getUserTransferState,
  (state: State) => state.transfersDeletedLoaded
);
